import { isPlatformBrowser } from '@angular/common'
import { inject, PLATFORM_ID, Resource } from '@angular/core'
import { rxResource } from '@angular/core/rxjs-interop'
import { of } from 'rxjs'

import { FormsApi } from 'app/core/forms-api'

export function injectApprovalResource(): Resource<string> {
  const formsApi = inject(FormsApi)
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID))

  // we ony want to load the approval token on the browser

  const approval = rxResource({
    defaultValue: '',
    stream: isBrowser ? () => formsApi.approvalToken$ : () => of(''),
  })

  return approval.asReadonly()
}
